import React, { Component } from 'react';
import MalidCard from './MalidCard';

import helpers from './../helpers';

class OrdanetView extends Component {
	render() {
		return (
			<MalidCard title={window.l('ordanet_title')}
				subTitle={window.l('ordanet_subtitle')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('ordanet_about')}
				database="ordanet">
				{
					this.props.data && this.props.data.map((item, index) => {
						let flettuLink = item.samheitavensl+item.parast+item.hugtakavensl+item.samsetningar === 0;

						return <React.Fragment key={index}>
							{
								index > 0 && <hr className="divider"/>
							}
							<p className="card-text">
								{

								}
								<a target='_blank' href={'https://ordanet.arnastofnun.is/fletta/'+(flettuLink ? item.fletta : item.id)}>{item.fletta}</a> {item.ordflokkur}{item.greining ? ' '+item.greining : ''}<br/>
								{
									item.samheitavensl > 0 &&
									<React.Fragment>Samheitavensl við {item.samheitavensl} {helpers.plural('flettu', 'flettur', item.samheitavensl)}. Sjá <a target='_blank' className="text-light" href={'https://ordanet.arnastofnun.is/fletta/grannheiti/'+item.id}>grannheiti</a> og <a target='_blank' className="text-light" href={'https://ordanet.arnastofnun.is/fletta/metin_vensl/'+item.id}>metin vensl</a>.<br/></React.Fragment>
								}
								{
									item.parast > 0 &&
									<React.Fragment>Parast við {item.parast} {helpers.plural('flettu', 'flettur', item.parast)}. Sjá <a target='_blank' className="text-light" href={'https://ordanet.arnastofnun.is/fletta/por/'+item.id}>{helpers.plural('par', 'pör', item.parast)}</a> og <a target='_blank' className="text-light" href={'https://ordanet.arnastofnun.is/fletta/skyldheiti/'+item.id}>skyldheiti</a>.<br/></React.Fragment>
								}
								{
									item.hugtakavensl > 0 &&
									<React.Fragment>Tengist {item.hugtakavensl} {helpers.plural('flettu', 'flettum', item.hugtakavensl)} innan hugtakanna <React.Fragment>
											{
												item.hugtok.map((hugtak, hIndex) => {
													return <React.Fragment key={hIndex}>
														{
															hIndex > 0 && hIndex === item.hugtok.length-1 &&
															<React.Fragment> og </React.Fragment>
														}
														{
															hIndex > 0 && hIndex < item.hugtok.length-1 && item.hugtok.length > 1 &&
															<React.Fragment>, </React.Fragment>
														}
														<a target='_blank' className="text-light" href={'https://ordanet.arnastofnun.is/fletta/hugtok/'+(hugtak.id || hugtak.hugtak)}>{hugtak.hugtak}</a>
													</React.Fragment>
												})
											}
										</React.Fragment><br/>
									</React.Fragment>
								}
								{
									item.samsetningar > 0 &&
									<React.Fragment>Liður í {item.samsetningar} <a target='_blank' className="text-light" href={'https://ordanet.arnastofnun.is/fletta/samsett/'+item.id}>{helpers.plural('samsetningu', 'samsetningum', item.samsetningar)}</a>.<br/></React.Fragment>
								}
								{
									item.fleiryrt > 0 &&
									<React.Fragment>Liður í {item.fleiryrt} {helpers.plural('fleiryrtri flettu', 'fleiryrtum flettum', item.fleiryrt)}.<br/></React.Fragment>
								}
							</p>
						</React.Fragment>
					})
				}
			</MalidCard>
		);
	}
}

export default OrdanetView;



// WEBPACK FOOTER //
// ./src/components/OrdanetView.js